module.exports = __webpack_public_path__ + "img/1w.8aa4c8d3.svg";